import InboxContainer from './InboxContainer';
export default InboxContainer;
